module.exports = __webpack_public_path__ + "img/m13.7002c9e5.jpg";